import Vue from 'vue'
import momentTimezone from 'moment-timezone'
Vue.prototype.$moment = momentTimezone
Vue.moment = momentTimezone

Vue.prototype.$dateFormat_HU = 'YYYY-MM-DD'
Vue.prototype.$dateFormat_EN = 'DD-MM-YYYY'
Vue.prototype.$dateTimeFormat_HU = 'YYYY-MM-DD HH:mm'
Vue.prototype.$dateTimeFormat_EN = 'DD-MM-YYYY HH:mm'
Vue.prototype.$dateTimeSecondFormat_HU = 'YYYY-MM-DD HH:mm:ss'
Vue.prototype.$dateTimeSecondFormat_EN = 'DD-MM-YYYY HH:mm:ss'
Vue.prototype.$dayMonthFormat_1_HU = 'MMM DD, ddd'
Vue.prototype.$dayMonthFormat_1_EN = 'ddd, DD MMM'
Vue.prototype.$dayMonthFormat_2_HU = 'MMM DD'
Vue.prototype.$dayMonthFormat_2_EN = 'DD MMM'
Vue.prototype.$dayMonthFormat_3_HU = 'ddd DD'
Vue.prototype.$dayMonthFormat_3_EN = 'ddd DD'
Vue.prototype.$dayMonthFormat_4_HU = 'MMMM DD, dddd'
Vue.prototype.$dayMonthFormat_4_EN = 'dddd, DD MMMM'
Vue.prototype.$dayMonthTimeFormat_HU = 'MMM D, ddd, HH:mm'
Vue.prototype.$dayMonthTimeFormat_EN = 'ddd, D MMM,  HH:mm'
Vue.prototype.$hour = 'HH:mm'
Vue.prototype.$year = 'YYYY'
Vue.prototype.$deliveryPeriod = 30

Vue.prototype.$calendarFormat1 = (locale) => {
    return {
        sameDay: `[${Vue.i18n.translate('base.today', locale)}]`,
        nextDay: `[${Vue.i18n.translate('base.tomorrow', locale)}]`,
        nextWeek: 'dd',
        lastDay: 'dd',
        lastWeek: 'dd',
        sameElse: 'dd',
    }
}
Vue.prototype.$calendarFormat2 = (locale) => {
    return {
        sameDay: `[${Vue.i18n.translate('base.today', locale)}]`,
        nextDay: `[${Vue.i18n.translate('base.tomorrow', locale)}]`,
        nextWeek: 'dddd',
        lastDay: 'dddd - MMM DD',
        lastWeek: 'ddd - MMM DD',
        sameElse: 'dddd - MMM DD',
    }
}
